export const environment = {
    production: false,
    basePath: ' https://teamfundedbackend.mi2.in/api/',
    donationsBasePath: 'https://teamfundeddonation.mi2.in/donation/',
    bucketName: 'teamfunded-dev',
    awsBasePath: 'https://s3-us-west-2.amazonaws.com/teamfunded-dev/images/',
    awsVideoBasePath: 'https://s3-us-west-2.amazonaws.com/teamfunded-dev/videos/',
    bucketRegion: 'us-east-1'
  };
  